module.exports = __webpack_public_path__ + "images/apple-touch-icon-76x76-8706a74d3e7f3967043d166e6d7bcd9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/apple-touch-icon-76x76.png
// module id = ./src/images/favicons/apple-touch-icon-76x76.png
// module chunks = 1